import styled from 'styled-components'
export const Header = styled.h4`
  margin-top: 22px;
  max-width: 470px;
  text-align: center;
`

export const Body = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 4px;
  height: 100%;
  padding: 16px;

  .button.primary,
  .button.secondary,
  .button.tertiary {
    min-width: 60px;
  }
`

export const ButtonClose = styled.button`
  display: flex;
  position: absolute;
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  top: 4px;
  right: 4px;
  width: 40px;
  height: 40px;
  background-color: var(--danger);
  color: var(--white);
  transition: 0.3s ease;

  &:hover {
    transition: 0.3s ease;
    opacity: 0.7;
  }

  img {
    width: 12px;
  }
`
